import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const StyHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${SPACING._4};
  margin-bottom: ${SPACING._8};
`;

export const StyContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._12};

  > button[type='submit'] {
    margin-top: ${SPACING._8};
  }

  a {
    width: fit-content;
    > span {
      transition: 200ms;
      width: fit-content;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.primary};
      }
    }
  }
`;

export const StyOpenAccount = styled.div`
  padding-top: ${SPACING._16};
`;
